import api from './api';

class AuthService {
  async login(email, password) {
    try {
      const response = await api.post('/auth/login', { email, password });
      const { user, token } = response.data || {};

      if (!user || !token) {
        return {
          success: false,
          error: 'Resposta de login inválida. Recarregue a página e tente novamente.',
        };
      }

      const authData = {
        token,
        userId: user.id,
        email: user.email
      };

      localStorage.setItem('vidal_auth', JSON.stringify(authData));
      localStorage.setItem('vidal_user', JSON.stringify(user));

      if (user.projetos && user.projetos.length > 0) {
        localStorage.setItem('vidal_selected_project', user.projetos[0]);
      }

      return { success: true, user, token };
    } catch (error) {
      console.error('Login error:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Erro ao fazer login'
      };
    }
  }

  async register({ name, email, password, certificateFile, certPassword, segmento, plan, billingClass }) {
    try {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('email', email);
      formData.append('password', password);
      formData.append('certPassword', certPassword);
      if (segmento) formData.append('segmento', segmento);
      if (plan) formData.append('plan', plan);
      if (billingClass) formData.append('billingClass', billingClass);
      formData.append('certificate', certificateFile);

      const response = await api.post('/auth/register', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const { user, token, projectId, cnpj, companyName } = response.data;

      if (token && user) {
        const authData = {
          token,
          userId: user.id,
          email: user.email
        };

        localStorage.setItem('vidal_auth', JSON.stringify(authData));
        localStorage.setItem('vidal_user', JSON.stringify(user));

        if (projectId) {
          localStorage.setItem('vidal_selected_project', projectId);
          localStorage.setItem('vidal_current_project_data', JSON.stringify({
            nome: companyName || cnpj,
            cnpj: cnpj,
            color: '#10b981',
          }));
        } else if (user.projetos && user.projetos.length > 0) {
          localStorage.setItem('vidal_selected_project', user.projetos[0]);
        }
      }

      return { success: true, user, token, autoLogin: !!token };
    } catch (error) {
      console.error('Register error:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Erro ao criar conta'
      };
    }
  }

  async getMe() {
    try {
      const response = await api.get('/auth/me');
      const user = response.data.user;
      localStorage.setItem('vidal_user', JSON.stringify(user));
      return { success: true, user };
    } catch (error) {
      console.error('Get me error:', error);
      // Propaga o status HTTP para quem chamou decidir se é falha real de
      // autenticação (401/403) ou apenas um erro transitório (rate limit,
      // rede, 5xx) — nesse segundo caso NÃO deve deslogar o usuário.
      return { success: false, status: error.response?.status, error: 'Erro ao buscar dados do usuário' };
    }
  }

  logout() {
    localStorage.removeItem('vidal_auth');
    localStorage.removeItem('vidal_user');
    localStorage.removeItem('vidal_selected_project');
  }

  isAuthenticated() {
    const authData = localStorage.getItem('vidal_auth');
    return !!authData;
  }

  getUser() {
    const userData = localStorage.getItem('vidal_user');
    return userData ? JSON.parse(userData) : null;
  }

  getToken() {
    const authData = localStorage.getItem('vidal_auth');
    return authData ? JSON.parse(authData).token : null;
  }

  setSelectedProject(projectId) {
    localStorage.setItem('vidal_selected_project', projectId);
  }

  getSelectedProject() {
    return localStorage.getItem('vidal_selected_project');
  }
}

export default new AuthService();
